import { RPCDocs } from "../../../services/rpc.js";
import { UserAnPCheck } from "../../shared/UserAnPCheck.js";
import { useCurrentUserAnPCheck } from "../../AuthWrapper2/hooks/useCurrentUserAnPCheck.js";
import { ManageOrganizationSubscription } from "./Subcription/index.js";
import { useMemo } from "react";
import { Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdBlock } from "react-icons/md";
// src/modules/Organizations/shared/OrganizationClientAccessBlocked.tsx
var RoleElement = RPCDocs.Auth.GetIdentityInfo.v1.Roles;
function OrganizationClientAccessBlocked({ identityInfo }) {
	const canManageSubscription = useCurrentUserAnPCheck((user) => user.anp.roles.includes(RoleElement.Admin) && user.anp.role.admin.permissions.manageOrganizationSubscription);
	const [adminBlockTypeDescription, showOrganizationSubscriptionUI] = useMemo(() => {
		switch (identityInfo.organization.clientAccess?.blockReason || "") {
			case "billing_delinquent": return [`Your Organization access is restricted until a subscription billing issue is resolved.`, canManageSubscription];
			case "billing_trial_end": return [`Your Organization access is restricted because the trial period has ended.`, canManageSubscription];
			case "manual_block": return [`Your Organization access is restricted. An admin from your Organization needs to contact THERMS Support to resolve the issue.`, false];
			default: return [`Your Organization access is restricted.`, false];
		}
	}, [identityInfo]);
	return /* @__PURE__ */ jsx("div", {
		className: "h-full w-full",
		children: /* @__PURE__ */ jsxs("div", {
			className: "gap-y-xl flex h-full w-full flex-col items-center justify-center",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "text-color-critical text-lg font-bold",
				children: [/* @__PURE__ */ jsx(Icon, { Icon: MdBlock }), " Access Temporarily Restricted"]
			}), identityInfo.user.anp.roles.includes(RoleElement.Admin) ? /* @__PURE__ */ jsxs("div", {
				className: "text-center",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: "mb-base text-color-critical text-lg font-bold",
						children: identityInfo.organization.clientAccess?.blockMessage
					}),
					/* @__PURE__ */ jsx("div", {
						className: "mb-xxl font-bold",
						children: adminBlockTypeDescription
					}),
					showOrganizationSubscriptionUI && /* @__PURE__ */ jsx(UserAnPCheck, {
						check: (user) => user.anp.role.admin.permissions.manageOrganizationSubscription,
						children: /* @__PURE__ */ jsx(ManageOrganizationSubscription, {})
					})
				]
			}) : /* @__PURE__ */ jsxs("div", {
				className: "font-light",
				children: [
					"Contact the administrator(s) for",
					" ",
					/* @__PURE__ */ jsx("strong", { children: identityInfo.organization.name }),
					" to resolve this restriction."
				]
			})]
		})
	});
}
export { OrganizationClientAccessBlocked };

//# sourceMappingURL=OrganizationClientAccessBlocked.js.map